import React from 'react';
import { useSelector } from 'react-redux';
import {
    getCurrencySymbol,
    toFixedTrunc,
    useJunoCommonFunctions,
} from '../../../../client/Juno/helpers';
import PropTypes from 'prop-types';
import MobileConfirmation from '../MoobileConfirmaion';
import { formatCurrency } from '../../../helpers/constant';

const FxConfirmation = ({ formData, fxRate }) => {
    const balancesFiatData = useSelector(state => state.juno.balancesCurrencies);
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const { useWindowWidth } = useJunoCommonFunctions();

    const windowWidth = useWindowWidth();

    // Handle both object and string formats for currency IDs
    const fromCurrencyShortName = formData.fromFiatId?.currencyShortName || formData.fromFiatId;
    const toCurrencyShortName = formData.toFiatId?.currencyShortName || formData.toFiatId;

    // Get currency icon from balances data
    const fromFiatIcon = balancesFiatData.find(
        x => x.currencyShortName === fromCurrencyShortName,
    )?.currencyIcon;

    const toFiatIcon = balancesFiatData.find(
        x => x.currencyShortName === toCurrencyShortName,
    )?.currencyIcon;

    // Get balances for from and to currencies
    const fromCurrencyBalance =
        formData.fromFiatId?.balanceAmount ||
        balancesFiatData.find(x => x.currencyShortName === fromCurrencyShortName)?.balanceAmount ||
        0;

    const toCurrencyBalance =
        formData.toFiatId?.balanceAmount ||
        balancesFiatData.find(x => x.currencyShortName === toCurrencyShortName)?.balanceAmount ||
        0;

    const data = {
        title: 'From',
        amount: formatCurrency(formData.fromFiatAmount, fromCurrencyShortName),
        balance: formatCurrency(fromCurrencyBalance, fromCurrencyShortName),
        currencyIcon: fromFiatIcon,
        toTitle: 'To',
        toAmount: formatCurrency(formData.toFiatAmount, toCurrencyShortName),
        toBalance: formatCurrency(toCurrencyBalance, toCurrencyShortName),
        toCurrencyIcon: toFiatIcon,
        details: [
            {
                label: 'rate',
                value: (
                    <span>
                        {' '}
                        1 {fromCurrencyShortName} = {toFixedTrunc(fxRate, 4)} {toCurrencyShortName}
                    </span>
                ),
            },
        ],
    };

    if (windowWidth <= 640) return <MobileConfirmation data={data} component={'fx'} />;

    return (
        <div className="flex flex-col gap-6">
            {/* FROM Block */}
            <div className="">
                <p className="text-xs font-medium text-balanceCard-manage uppercase mb-2">From</p>
                <div className="border !border-input-border bg-card-bg rounded-md p-3">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                            {fromFiatIcon && (
                                <img
                                    src={`${imageBaseUrl}${fromFiatIcon}`}
                                    width={24}
                                    height={24}
                                    alt="fromCurrencyIcon"
                                    className="rounded-full"
                                />
                            )}
                            <span className="text-base font-medium !text-text">
                                {fromCurrencyShortName}
                            </span>
                        </div>
                        <p
                            className="text-xl font-medium !text-text"
                            data-e2e={formData.fromFiatAmount}
                            data-e2e-curren={fromCurrencyShortName}>
                            {getCurrencySymbol(fromCurrencyShortName)} {formData.fromFiatAmount} (
                            {fromCurrencyShortName})
                        </p>
                    </div>
                    <hr className="!border-input-border h-[1px] my-2" />
                    <div className="flex justify-between items-center">
                        <p className="text-xs font-medium text-balanceCard-manage">Balance:</p>
                        <p className="text-xs font-normal text-balanceCard-manage">
                            {toFixedTrunc(fromCurrencyBalance, 2)}
                        </p>
                    </div>
                </div>
            </div>

            {/* TO Block */}
            <div className="">
                <p className="text-xs font-medium text-balanceCard-manage uppercase mb-2">TO</p>
                <div className="border !border-input-border bg-card-bg rounded-md p-3">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                            {toFiatIcon && (
                                <img
                                    src={`${imageBaseUrl}${toFiatIcon}`}
                                    width={24}
                                    height={24}
                                    alt="toCurrencyIcon"
                                    className="rounded-full"
                                />
                            )}
                            <span className="text-base font-medium !text-text">
                                {toCurrencyShortName}
                            </span>
                        </div>
                        <p
                            className="text-xl font-medium !text-text"
                            data-e2e={formData.toFiatAmount}
                            data-e2e-curren={toCurrencyShortName}>
                            {getCurrencySymbol(toCurrencyShortName)} {formData.toFiatAmount} (
                            {toCurrencyShortName})
                        </p>
                    </div>
                    <hr className="!border-input-border h-[1px] my-2" />
                    <div className="flex justify-between items-center">
                        <p className="text-xs font-medium text-balanceCard-manage">Balance:</p>
                        <p className="text-xs font-normal text-balanceCard-manage">
                            {toFixedTrunc(toCurrencyBalance, 2)}
                        </p>
                    </div>
                </div>
            </div>

            {/* Rate Info */}
            <div className="border !border-input-border bg-card-bg rounded-md p-3 !text-text">
                <p className="text-center">
                    1 {fromCurrencyShortName} = {toFixedTrunc(fxRate, 4)} {toCurrencyShortName}
                </p>
            </div>
        </div>
    );
};

FxConfirmation.propTypes = {
    formData: PropTypes.object.isRequired,
    fxRate: PropTypes.number.isRequired,
};

export default FxConfirmation;
